import type { BotDescriptor } from '@/types';

/** Authentication and health for the TRX service; data is owned by the TRX views. */
export function createBotSubStore(botId: string) {
  const loginInfo = useLoginInfo(botId);
  const { api } = useApi(loginInfo, botId);
  const useConnectionStore = defineStore(botId, () => {
    const isBotOnline = ref(false);
    const isBotLoggedIn = ref(true);

    function setIsBotOnline(value: boolean) {
      isBotOnline.value = value;
    }

    async function fetchPing() {
      try {
        await api<{ status: string }>('/ping');
        setIsBotOnline(true);
      } catch (error) {
        setIsBotOnline(false);
        throw error;
      }
    }

    function logout() {
      loginInfo.logout();
    }

    function getLoginInfo() {
      return loginInfo.getLoginInfo();
    }

    function updateBot(values: Partial<BotDescriptor>) {
      loginInfo.updateBot(values);
    }

    return {
      isBotOnline,
      isBotLoggedIn,
      setIsBotOnline,
      fetchPing,
      logout,
      getLoginInfo,
      updateBot,
    };
  });

  if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useConnectionStore, import.meta.hot));
  }
  return useConnectionStore();
}
